<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateSetting(value: boolean) {
  await settingsStore.set('showNonStandardUnitHourRegistrationsDashboard', value);
}

const descriptionText = computed(() => {
  const baseDescription = t('hourRegistration.showNonStandardUnitHourRegistrationsDescriptionDashboard');
  
  if (!settingsStore.settings.homepageLayout.hourRegistrationOverview) {
    return [
      baseDescription,
      t('hourRegistration.showNonStandardUnitHourRegistrationsDescriptionDashboardActive')
    ].join('. ');
  }

  return baseDescription;
});
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.homepageLayout.hourRegistrationOverview ? settingsStore.settings.showNonStandardUnitHourRegistrationsDashboard : false"
    :label="t('hourRegistration.showNonStandardUnitHourRegistrationsDashboard')"
    :description="descriptionText"
    :disabled="!settingsStore.settings.homepageLayout.hourRegistrationOverview"
    @change="updateSetting"
  />
</template>